import { render, staticRenderFns } from "./EventGallery.vue?vue&type=template&id=afa3626e&"
import script from "./EventGallery.vue?vue&type=script&lang=js&"
export * from "./EventGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports